/*
  RAWS cart CRO: bundle bar (<raws-multibuy>, snippets/free-shipping-bar.liquid) and product page
  bundle line (<raws-bundle-offer>, snippets/raws-bundle-offer.liquid) follow the cart without a
  reload (cart writes are spotted via PerformanceObserver, so fetch/XHR are never patched); Shop Pay
  first in the drawer; size must be picked before Add to cart; drawer bundle bar scrolls to the picks.
  Copy: data-t-* attributes (storefront language); English fallbacks + size prompt live here.
  RAWSMULTI change: update THRESHOLD / PCT here AND in both snippets. Keep under 16 KB (API limit).
*/
(function () {
  'use strict';
  if (window.__rawsCartCro) return;
  window.__rawsCartCro = true;

  var THRESHOLD = 3;
  var PCT = 25;
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|#|$)/;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var lastCart = null;
  var pending = false;
  var timer = null;

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  // Message template from the element (storefront language), English if the attribute is missing.
  function tpl(el, name, fallback) {
    var t = el.getAttribute('data-t-' + name);
    return t || fallback;
  }

  function fill(template, values) {
    return template.replace(/\[(\w+)\]/g, function (m, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : m;
    });
  }

  function render(el, cart) {
    var threshold = parseInt(el.getAttribute('data-threshold'), 10) || THRESHOLD;
    var pct = parseInt(el.getAttribute('data-pct'), 10) || PCT;
    var count = cart.item_count || 0;
    var needed = threshold - count;

    el.hidden = count === 0;
    el.classList.toggle('is-unlocked', needed <= 0);

    var msg = el.querySelector('[data-raws-msg]');
    if (msg) {
      if (needed <= 0) {
        var save = cart.total_discount > 0
          ? ' <span class="raws-cro__save">' +
            fill(tpl(el, 'saving', '— you’re saving [amount]'), { amount: money(cart.total_discount, cart.currency) }) +
            '</span>'
          : '';
        msg.innerHTML = fill(tpl(el, 'unlocked', '<strong>[pct]% off unlocked</strong>'), { pct: pct }) + save;
      } else if (needed === 1) {
        msg.innerHTML = fill(tpl(el, 'one', 'Add <strong>1 more item</strong> to unlock [pct]% off'), { pct: pct });
      } else {
        msg.innerHTML = fill(tpl(el, 'many', 'Add <strong>[needed] more items</strong> to unlock [pct]% off'), { pct: pct, needed: needed });
      }
    }

    var countEl = el.querySelector('[data-raws-count]');
    if (countEl) countEl.textContent = Math.min(count, threshold) + '/' + threshold;

    var segs = el.querySelectorAll('.raws-cro__seg');
    for (var i = 0; i < segs.length; i++) segs[i].classList.toggle('is-on', count > i);
  }

  // Product page bundle line (<raws-bundle-offer>, snippets/raws-bundle-offer.liquid)
  function renderOffer(el, cart) {
    var threshold = parseInt(el.getAttribute('data-threshold'), 10) || THRESHOLD;
    var pct = parseInt(el.getAttribute('data-pct'), 10) || PCT;
    var count = cart.item_count || 0;
    var needed = threshold - count;
    var values = { n: threshold, pct: pct, count: count, needed: needed };

    el.classList.toggle('is-unlocked', count > 0 && needed <= 0);

    var msg = el.querySelector('[data-raws-offer-msg]');
    if (!msg) return;
    if (count === 0) {
      msg.innerHTML = fill(tpl(el, 'zero', '<strong>Buy any [n], save [pct]%</strong> — applied automatically'), values);
    } else if (needed <= 0) {
      msg.innerHTML = fill(tpl(el, 'unlocked', '<strong>[pct]% off unlocked</strong> — on everything in your cart'), values);
    } else {
      msg.innerHTML = fill(tpl(el, 'progress', '<strong>[count] in your cart</strong> — add [needed] more to save [pct]%'), values);
    }
  }

  function applyAll(cart) {
    lastCart = cart;
    var els = document.querySelectorAll('raws-multibuy');
    for (var i = 0; i < els.length; i++) render(els[i], cart);
    var offers = document.querySelectorAll('raws-bundle-offer');
    for (var j = 0; j < offers.length; j++) renderOffer(offers[j], cart);
  }

  function refresh() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { pending = false; if (cart) applyAll(cart); })
      .catch(function () { pending = false; });
  }

  function schedule() {
    pending = true;
    clearTimeout(timer);
    timer = setTimeout(refresh, 200);
  }

  // Watch for cart writes made by anything on the page (theme, Upsell.com, quick add, etc.)
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (list) {
        var entries = list.getEntries();
        for (var i = 0; i < entries.length; i++) {
          if (CART_WRITE.test(entries[i].name)) { schedule(); return; }
        }
      }).observe({ type: 'resource', buffered: false });
    } catch (e) { /* older browsers: Liquid render still shows the correct state on load */ }
  }

  // Back/forward cache restores a stale page: re-read the cart.
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });

  // The drawer is cloned from a <template> each time it opens. If the cart changed on this page
  // since that template was rendered, bring the freshly connected bar up to date.
  if (!customElements.get('raws-multibuy')) {
    customElements.define('raws-multibuy', class extends HTMLElement {
      connectedCallback() {
        if (lastCart && !pending) render(this, lastCart);
      }
    });
  }
  if (!customElements.get('raws-bundle-offer')) {
    customElements.define('raws-bundle-offer', class extends HTMLElement {
      connectedCallback() {
        if (lastCart && !pending) renderOffer(this, lastCart);
      }
    });
  }

  // Express checkout in the cart drawer (snippets/raws-cart-express.liquid). The buttons arrive
  // in a <template>; place exactly one copy right ABOVE <cart-drawer-buttons-block> so Shop Pay is
  // the first checkout option, and put it back if the drawer re-renders its footer.
  if (!customElements.get('raws-express-checkout')) {
    customElements.define('raws-express-checkout', class extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('[data-sidebar-body]') || this.closest('cart-drawer');
        if (!this.scope) return;
        this.place();
        if (!this.observer) {
          var self = this;
          this.observer = new MutationObserver(function () { self.place(); });
          this.observer.observe(this.scope, { childList: true, subtree: true });
        }
      }
      disconnectedCallback() {
        if (this.observer) { this.observer.disconnect(); this.observer = null; }
      }
      place() {
        var buttons = this.scope.querySelector('cart-drawer-buttons-block');
        var tpl = this.querySelector('template');
        if (!buttons || !tpl) return;
        var prev = buttons.previousElementSibling;
        if (prev && prev.classList.contains('raws-express')) return;
        var stale = this.scope.querySelectorAll('.raws-express');
        for (var i = 0; i < stale.length; i++) stale[i].remove();
        var node = document.importNode(tpl.content, true).firstElementChild;
        if (node) buttons.insertAdjacentElement('beforebegin', node);
      }
    });
  }

  // Product pages: a size has to be picked before Add to cart (main button, the theme's mobile
  // sticky button and quick view). The theme pre-selects the first available size, so a quick tap
  // on Add to cart used to add XS/S by default. Only real taps/keys on a size count as picking,
  // plus a page that opens on the size already tapped this visit (e.g. after switching colour).
  // The Size option is named in the storefront language, so match it in every language we sell in.
  var SIZE_NAME = /size|größe|grösse|taille|maat|talla|taglia|サイズ|사이즈|storlek|størrelse|koko|tamanho/i;
  var SIZE_NOTE = {
    en: 'Select your size',
    de: 'Wähle deine Größe',
    fr: 'Sélectionnez votre taille',
    nl: 'Kies je maat',
    es: 'Elige tu talla',
    it: 'Scegli la tua taglia',
    ja: 'サイズを選択してください',
    ko: '사이즈를 선택하세요',
    sv: 'Välj din storlek',
    da: 'Vælg din størrelse',
    nb: 'Velg din størrelse',
    fi: 'Valitse kokosi',
    pt: 'Selecione o seu tamanho'
  };
  var pageLang = String(document.documentElement.lang || 'en').toLowerCase().slice(0, 2);
  var sizeNote = SIZE_NOTE[pageLang] || SIZE_NOTE.en;
  var sizePicked = {};

  // The size the shopper last tapped on this visit. Switching colour opens the other colour's page
  // with that size already chosen, so a page that opens on it counts as picked and doesn't ask again.
  var PICK_KEY = 'raws_size_pick';
  var PICK_TTL = 6 * 60 * 60 * 1000;

  function lastPick() {
    try {
      var p = JSON.parse(window.sessionStorage.getItem(PICK_KEY) || 'null');
      return p && p.v && Date.now() - p.t < PICK_TTL ? String(p.v) : null;
    } catch (err) {
      return null;
    }
  }

  function rememberPick(value) {
    try {
      window.sessionStorage.setItem(PICK_KEY, JSON.stringify({ v: value, t: Date.now() }));
    } catch (err) {}
  }

  function sizeRadios(formId) {
    return Array.prototype.filter.call(
      document.querySelectorAll('input[type="radio"][form="' + formId + '"]'),
      function (i) { return SIZE_NAME.test(i.name || ''); }
    );
  }

  function isPicked(formId, sizes) {
    if (sizePicked[formId]) return true;
    var pick = lastPick();
    if (!pick) return false;
    for (var i = 0; i < sizes.length; i++) {
      if (sizes[i].checked && sizes[i].value === pick) {
        sizePicked[formId] = true;
        return true;
      }
    }
    return false;
  }

  function sizeGroupOf(input) {
    var picker = input.closest('variant-picker');
    if (!picker) return null;
    var groups = picker.querySelectorAll('[data-variant-picker-option-labels]');
    for (var i = 0; i < groups.length; i++) {
      if ((groups[i].getAttribute('option-picker-name') || '') === input.name) return groups[i];
    }
    return null;
  }

  // Until a size is picked, none looks selected (raws-size-unset in raws-cart-cro.css). The theme
  // quietly pre-selects the first size, which made a size look chosen while the page still asked.
  function paintSizes() {
    var pickers = document.querySelectorAll('variant-picker');
    for (var i = 0; i < pickers.length; i++) {
      var radios = pickers[i].querySelectorAll('input[type="radio"][form]');
      var first = null;
      for (var j = 0; j < radios.length; j++) {
        if (SIZE_NAME.test(radios[j].name || '')) { first = radios[j]; break; }
      }
      if (!first) continue;
      var group = sizeGroupOf(first);
      if (!group) continue;
      var formId = first.getAttribute('form');
      var sizes = sizeRadios(formId);
      var unset = sizes.length > 1 && !isPicked(formId, sizes);
      if (group.classList.contains('raws-size-unset') !== unset) group.classList.toggle('raws-size-unset', unset);
    }
  }

  // Repaint when the theme redraws a picker or opens quick view (batched to one pass per frame).
  var paintQueued = false;
  function queuePaint() {
    if (paintQueued) return;
    paintQueued = true;
    (window.requestAnimationFrame || setTimeout)(function () {
      paintQueued = false;
      paintSizes();
    });
  }
  paintSizes();
  if (window.MutationObserver) {
    new MutationObserver(queuePaint).observe(document.body, { childList: true, subtree: true });
  }

  function sizeRadioFrom(target) {
    if (!target || !target.closest) return null;
    if (target.type === 'radio' && SIZE_NAME.test(target.name || '') && target.getAttribute('form')) return target;
    var label = target.closest('label[for]');
    if (!label) return null;
    var input = document.getElementById(label.getAttribute('for'));
    return input && input.type === 'radio' && SIZE_NAME.test(input.name || '') && input.getAttribute('form') ? input : null;
  }

  function markPicked(e) {
    if (!e.isTrusted) return;
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    var input = sizeRadioFrom(e.target);
    if (!input) return;
    sizePicked[input.getAttribute('form')] = true;
    rememberPick(input.value);
    var picker = input.closest('variant-picker');
    if (!picker) return;
    var notes = picker.querySelectorAll('.raws-size-note');
    for (var i = 0; i < notes.length; i++) notes[i].remove();
    var groups = picker.querySelectorAll('.raws-size-needed, .raws-size-unset');
    for (var j = 0; j < groups.length; j++) {
      groups[j].classList.remove('raws-size-needed');
      groups[j].classList.remove('raws-size-unset');
    }
  }
  document.addEventListener('click', markPicked, true);
  document.addEventListener('change', markPicked, true);
  document.addEventListener('keydown', markPicked, true);

  function askForSize(input) {
    var group = sizeGroupOf(input) || input.closest('variant-picker');
    if (!group) return;
    group.classList.remove('raws-size-needed');
    void group.offsetWidth;
    group.classList.add('raws-size-needed');
    if (!group.querySelector('.raws-size-note')) {
      var note = document.createElement('p');
      note.className = 'raws-size-note';
      note.setAttribute('role', 'alert');
      note.textContent = sizeNote;
      group.appendChild(note);
    }
    group.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('button[name="add"]') : null;
    if (!btn || btn.disabled) return;
    var holder = btn.closest('product-form');
    var form = holder && holder.querySelector('form[data-type="add-to-cart-form"]');
    // getAttribute, not form.id: the form holds an <input name="id">, which form.id would return.
    var formId = form && form.getAttribute('id');
    if (!formId) return;
    var sizes = sizeRadios(formId);
    if (sizes.length < 2 || isPicked(formId, sizes)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    askForSize(sizes[0]);
  }, true);

  // Drawer bundle bar: until the bundle is unlocked, tapping its message scrolls down to the
  // "Build your bundle" picks, which sit below the items once two or more are in the cart.
  document.addEventListener('click', function (e) {
    var msg = e.target.closest ? e.target.closest('cart-drawer raws-multibuy .raws-cro__msg') : null;
    if (!msg) return;
    var bar = msg.closest('raws-multibuy');
    if (!bar || bar.classList.contains('is-unlocked')) return;
    var drawer = bar.closest('cart-drawer');
    var picks = drawer && drawer.querySelector('cart-drawer-related-products-block, .cart-drawer__in-cart-related-products');
    if (!picks) return;
    e.preventDefault();
    // Scroll only the drawer's own list, so the page behind the drawer never moves.
    var list = picks.closest('.cart-drawer__content');
    if (!list) {
      picks.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    function go() {
      var y = picks.getBoundingClientRect().top - list.getBoundingClientRect().top + list.scrollTop - 8;
      if (list.scrollTo) list.scrollTo({ top: y, behavior: 'smooth' });
      else list.scrollTop = y;
    }
    go();
    // The picks load just after the drawer opens. If they arrive after the tap, follow them down once.
    if (window.ResizeObserver) {
      var h = picks.offsetHeight;
      var ro = new ResizeObserver(function () {
        if (picks.offsetHeight > h + 40) { ro.disconnect(); go(); }
      });
      ro.observe(picks);
      setTimeout(function () { ro.disconnect(); }, 4000);
    }
  });
})();